import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAVEL = {
  nickname: 'PRODUCTS.TRAVEL.shortname',
  properties: [
    {
      name: 'travelSingleTripExtensionMonths', key: 'TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.3', value: '3' },
        ]
      }
    },
    {
      name: 'travelType', key: 'TRAVEL_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isStormTravelNumberOfInsuredPersonsCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.PERSONAL', value: 'PERSONAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.FAMILY', value: 'FAMILY' },
        ]
      }
    },
    {
      name: 'travelNumberOfInsuredPersons', key: 'TRAVEL_NUMBER_OF_INSURED_PERSONS', group: 'INSURANCE_INFO'
    },
  ],
  icon: 'travel'
};
